import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const sendContact = (payload) =>
  axios.post(`${API}/contact`, payload).then((r) => r.data);
